import * as React from 'react';
import {
    Avatar,
    Box,
    Button,
    Divider,
    Menu,
    MenuItem,
    useTheme
} from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PersonIcon from '@mui/icons-material/Person';
import TuneIcon from '@mui/icons-material/Tune';
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import axios from 'axios';
import { useSessionData } from "../../auth/SessionDataProvider";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import {Feedback} from "@mui/icons-material";
import AutoModeIcon from '@mui/icons-material/AutoMode';

const NeonMenu = styled(Menu)(({ theme }) => ({
    '& .MuiPaper-root': {
        background: 'linear-gradient(to right, #1c1f2a, #2d3142)',
        borderRadius: 16,
        minWidth: 250,
        padding: theme.spacing(2),
        border: '2px solid #7a52e0',
        boxShadow: '0 0 25px rgba(122, 82, 224, 0.3)',
    },
    '& .MuiMenuItem-root': {
        padding: theme.spacing(1.5),
        color: '#fff',
        fontWeight: 500,
        borderRadius: 8,
        transition: 'background 0.3s ease',
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.3),
        },
        '& svg': {
            marginRight: theme.spacing(2),
            color: '#ffe066',
        },
    },
    '& .MuiDivider-root': {
        backgroundColor: '#444',
        margin: `${theme.spacing(1)} 0`,
    },
}));

export default function UserMenu() {
    const { data, sessionData } = useSessionData();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const LogOut = () => {
        localStorage.clear();
        axios.post('/api/user/logOut').then(() => {
            window.location.href = '/';
        });
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
            <Button
                id="settings-button"
                aria-controls={open ? 'user-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <Avatar alt={sessionData.nickname} src={sessionData.profileImage} sx={{ border: '2px solid #fff' }} />
            </Button>

            <NeonMenu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {/*<Box sx={{ px: 1.5, py: 1 }}>*/}
                {/*    <GameModeSelector sx={{ mt: 1 }} />*/}
                {/*</Box>*/}

                {/*<Divider />*/}

                {/*<MenuItem component={Link} to="/user/profile" onClick={handleClose}>*/}
                {/*    <PersonIcon /> Profile*/}
                {/*</MenuItem>*/}
                {/*<MenuItem component={Link} to="/user/settings" onClick={handleClose}>*/}
                {/*    <TuneIcon /> Settings*/}
                {/*</MenuItem>*/}
                {sessionData.isUserAdmin && (
                    <>
                        <MenuItem component={Link} to="/admin/dashboard" onClick={handleClose}>
                            <SettingsIcon /> Admin Panel
                        </MenuItem>
                        <Divider />
                    </>
                )}

                <MenuItem component={Link} to="/create/room" onClick={handleClose}>
                    <MeetingRoomIcon /> Create Room
                </MenuItem>

                <Divider />

                <MenuItem component={Link} to="/wizard" onClick={handleClose}>
                    <AutoFixHighIcon /> Skrach Wizard
                </MenuItem>
                <MenuItem component={Link} to="/user/skraches" onClick={handleClose}>
                    <FormatListBulletedIcon /> My Skraches
                </MenuItem>
                <MenuItem component={Link} to="/feedback" onClick={handleClose}>
                    <Feedback /> Feedback
                </MenuItem>
                <Divider />

                {sessionData.isUserAdmin && (
                    <>
                        <MenuItem component={Link} to="/autoplay" onClick={handleClose}>
                            <AutoModeIcon />
                            Autoplay
                        </MenuItem>
                        <Divider />
                    </>
                )}

                <MenuItem onClick={() => { handleClose(); LogOut(); }}>
                    <ExitToAppIcon /> Logout
                </MenuItem>
            </NeonMenu>
        </Box>
    );
}
